var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-avatar"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.avatar),expression:"avatar"}],staticClass:"c-avatar-img"}),_c('div',{staticClass:"c-avatar-username"},[_vm._v(_vm._s(_vm.username))])])
}
var staticRenderFns = []

export { render, staticRenderFns }